import {BACKGROUND_REFETCH_THROTTLE_INTERVAL_IN_MS, FOREGROUND_REFETCH_THROTTLE_INTERVAL_IN_MS} from '../constants'

import {useStatusChecksPageDataQueryKey} from '../page-data/loaders/use-status-checks-page-data'
import {usePageVisibility} from './use-page-visibility'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'

export function useStatusChecksLiveUpdates(channel: string, pullRequestHeadSha: string): void {
  const queryKey = useStatusChecksPageDataQueryKey({pullRequestHeadSha})
  const isPageVisible = usePageVisibility()

  const throttleTiming = isPageVisible
    ? FOREGROUND_REFETCH_THROTTLE_INTERVAL_IN_MS
    : BACKGROUND_REFETCH_THROTTLE_INTERVAL_IN_MS

  useInvalidateOnAliveUpdate(channel, queryKey, {throttleTimeout: throttleTiming})
}
